(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("g7Sp6", function(module, exports) {
const $bbd7804aa34cffdb$var$initGalleryGroup = ()=>{
    const gallery = document.querySelectorAll(".s-variant-intro__gallery-slider");
    gallery.forEach((section)=>{
        const gallerySlider = section.querySelector(".g-gallery-slider__large-img .g-gallery-slider");
        const gallerySlidersOverview = section.querySelector(".g-gallery-slider__wrapper .g-gallery-slider");
        if (!gallerySlider || !gallerySlidersOverview) return;
        const largeImages = section.querySelectorAll(".g-gallery-slider__large-img button");
        largeImages.forEach((img)=>{
            img.addEventListener("click", ()=>{
                const galleryLg = img.closest(".g-gallery-slider__large-img");
                const galleryLgActiveItem = img.closest(".swiper-slide");
                const gallery = galleryLg?.closest("section")?.querySelector(".g-gallery-slider__wrapper .g-gallery-slider");
                if (!gallery) return;
                const galleryItems = Array.from(gallery?.querySelectorAll(".swiper-slide"));
                const selector = galleryLgActiveItem?.getAttribute("data-index");
                const slideActive = galleryItems[Number(`${selector}`)];
                const imgActive = slideActive?.querySelector("a");
                imgActive?.click();
            });
        });
    });
};
$bbd7804aa34cffdb$var$initGalleryGroup();
document.addEventListener("groupGalleryReinit", $bbd7804aa34cffdb$var$initGalleryGroup);

});

})();
//# sourceMappingURL=gallery-slider-group.716fc822.js.map
